import { useEffect, useState } from 'react';

interface WindowSize {
  width: number;
  height: number;
}

export const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: document.querySelector('.map-editor-container')?.clientWidth || 0,
    height: document.querySelector('.kmap-editor-container')?.clientHeight || 0
  });

  useEffect(() => {
    const handleResize = () => {
      // with setWindowSize get the .konvajs-content div and set the width and height to the window size
      setWindowSize({
        width:
          document.querySelector('.map-editor-container')?.clientWidth || 0,
        height:
          document.querySelector('.map-editor-container')?.clientHeight || 0
      });

      setTimeout(() => {
        // with setWindowSize get the .konvajs-content div and set the width and height to the window size
        setWindowSize({
          width:
            document.querySelector('.map-editor-container')?.clientWidth || 0,
          height:
            document.querySelector('.map-editor-container')?.clientHeight || 0
        });
      }, 20);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call once to set initial size
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};
